module.exports = __webpack_public_path__ + "img/icon-checked.5c98d061.svg";